import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { RoundButton } from '../shared/Buttons';
import Arrow from '@client/assets/svgs/arrow.svg';
import PageHandler from '@client/core/PageSwitch/PageHandler';

const BackArrowContainer = styled.div`
	padding-bottom: 30px;
	z-index: 1;
`;

const StyledRoundButton = styled(RoundButton)`
	svg path {
		stroke: currentColor;
	}

	${Functions.breakpoint(Breakpoints.mobile, 'max')} {
		background: none;
	}

	${Functions.breakpoint(Breakpoints.mobile)} {
		padding-bottom: 0px;
		margin-left: -26px;
		justify-content: center;
	}
`;

type ContentPageBackButton = {
	color?: {
		color: string;
		contrastColor: string;
	};
	parent?: {
		_prefix?: string;
		slug: string;
	};
};

export default function ContentPageBackButton(props: ContentPageBackButton) {
	const link = useMemo(() => {
		if (!props.parent) return;
		const prev = PageHandler.getInstance().previousLink;
		const parent = props.parent?._prefix + props.parent?.slug;
		if (prev?.startsWith(parent)) return;
		return { link: parent };
	}, [props.parent]);

	const onclick = useMemo(() => {
		if (link) return;
		return () => history.back();
	}, [link]);

	return (
		<BackArrowContainer>
			<StyledRoundButton
				colors={{
					bg: props.color?.color,
					fg: props.color?.contrastColor,
				}}
				link={link}
				onClick={onclick}
			>
				<Arrow />
			</StyledRoundButton>
		</BackArrowContainer>
	);
}
